/**
 * The seam between "who is signed in" and "how do I call the API".
 *
 * The API client is a plain module — it must not import React, and it must not
 * know whether the credential came from Auth0 or from the local dev bypass.
 * The active auth provider registers a handle here on mount; the client reads
 * it. One indirection, two auth modes, no duplicated fetch logic.
 */

export interface AuthHandle {
  /** `Authorization` header value, or null when signed out. */
  getAuthorization(): Promise<string | null>
  /**
   * Force a fresh credential after a 401. Auth0 re-runs the refresh-token
   * grant; the bypass mode has nothing to refresh and resolves immediately.
   */
  refresh(): Promise<void>
  /** Credential is unrecoverable — send the user back to sign in. */
  onUnauthorized(): void
}

const signedOut: AuthHandle = {
  getAuthorization: async () => null,
  refresh: async () => {},
  onUnauthorized: () => {},
}

let handle: AuthHandle = signedOut

export function setAuthHandle(next: AuthHandle | null): void {
  handle = next ?? signedOut
}

export function getAuthHandle(): AuthHandle {
  return handle
}
